export default "__VITE_ASSET__DKWcb951__"